export default __webpack_public_path__ + "static/media/Button.de8448fb.svg";